import React from 'react';
import { App } from '@mb/App';
import ReactDOM from 'react-dom';

import { ThemeContainer } from 'ui-widgets';

import { AppContainer } from '../../pages/Events/containers/AppContainer/AppContainer';

const EventsApp = () => {
  return (
    <App>
      <ThemeContainer>
        <AppContainer />
      </ThemeContainer>
    </App>
  );
};

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<EventsApp />, document.getElementById('eventsContent'));
